import type { ReactElement } from 'react';
import { Stack } from '@mantine/core';
import TopicSummaryPanel from '@/shared/surfaces/TopicSummaryPanel';
import type { StatItem } from '@/design/StatBand';
import { formatCount } from '@/shared/analytics/MetricFormatting';
import type { LicenseCostPageViewModel } from '@/features/licenses/LicenseCostPageViewModel';
import { makeCurrencyFormatter } from '@/features/licenses/CostFormatting';
import SpendCostInsights from './SpendCostInsights';

/** The shared Cost drill rail: a spend summary card over the AI insights card — the right column on every Spend › Cost page. */
export default function SpendCostRail({ vm, scopeKey }: { vm: LicenseCostPageViewModel; scopeKey: string }): ReactElement {
    const formatCurrency = makeCurrencyFormatter(vm.currency);
    const recordCount = vm.providerCosts.reduce((sum, group) => sum + group.records.length, 0);
    const stats: StatItem[] = [
        { label: 'Total spend', value: formatCurrency(vm.grandTotal), hint: 'across the selected range' },
        { label: 'Providers', value: formatCount(vm.providerCosts.length), hint: 'with cost data' },
        { label: 'Cost records', value: formatCount(recordCount), hint: 'invoice & seat lines' },
    ];
    return (
        <Stack gap="md">
            <TopicSummaryPanel stats={stats} />
            <SpendCostInsights providerCosts={vm.providerCosts} grandTotal={vm.grandTotal} scopeKey={scopeKey} />
        </Stack>
    );
}
